import types from "../types";

export const setDefaultPayment = (defaultPaymentMethod) => (
  dispatch,
  getState
) => {
  dispatch({
    type: types.SET_PAYMENT_METHOD,
    payload: { defaultPaymentMethod },
  });
};

export const removeDefaultPayment = (defaultPaymentMethod) => (
  dispatch,
  getState
) => {
  dispatch({
    type: types.REMOVE_PAYMENT_METHOD,
    payload: { defaultPaymentMethod },
  });
};
